import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyLinkedInUrl($linkedInUrl: String) {
    updateMyLinkedInUrl(linkedInUrl: $linkedInUrl) 
},
`;

export default async function updateMyLinkedInUrl(linkedInUrl?: string) {
    const variables: OperationVariables = {
        linkedInUrl: linkedInUrl || null,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
